<template>
  <div
    class="d-book-bottom-actions"
    :class="{ 'shown': isShown }"
  >
    <div class="wrapper">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
import SASS from '@dui/helpers/sass';

const HEADER_HEIGHT = 415;

export default {
  data: () => ({
    isShown: false,
  }),
  beforeDestroy() {
    this.removeEventListeners();
  },
  mounted() {
    this.addEventListeners();
  },
  methods: {
    addEventListeners() {
      window.addEventListener('resize', this.windowChangePerformed);
      window.addEventListener('scroll', this.windowChangePerformed);
    },
    removeEventListeners() {
      window.removeEventListener('resize', this.windowChangePerformed);
      window.removeEventListener('scroll', this.windowChangePerformed);
    },
    windowChangePerformed() {
      if (window.innerWidth < SASS.menuBreakpoint.md) {
        return;
      }

      this.isShown = (window.scrollY > HEADER_HEIGHT);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-book-bottom-actions {
  background-color: getColor($white);
  bottom: -100px;
  box-shadow: $box-shadow-context-menu;
  left: 0;
  opacity: 0;
  padding: $_2em 0;
  pointer-events: none;
  position: fixed;
  width: 100%;
  z-index: $z-index-sticky-actions;

  @include screenLessThanCustom($menu-md-breakpoint) {
    display: none;
  }

  @include transition((
    bottom,
    opacity,
  ));

  &.shown {
    bottom: 0;
    opacity: 1;
    pointer-events: all;
  }
}
</style>
